(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-chair-experience"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('relaxway-chair-experience')) {
  customElements.define('relaxway-chair-experience', class extends HTMLElement {
    connectedCallback() {
      const options = document.getElementById(this.dataset.optionsId);
      const bar = this.querySelector('.rlx-pdp-mobile-bar');
      if (options && bar && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { bar.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.bottom > 0; });
        this.observer.observe(options);
      }
      if (new URLSearchParams(location.search).get('contact_posted') === 'true' || this.querySelector('[role="alert"]')) {
        const review = this.querySelector('.rlx-pdp-review-form');
        if (review) review.open = true;
      }
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-relaxway-welcome"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('relaxway-welcome')) {
  customElements.define('relaxway-welcome', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const remember = () => { try {sessionStorage.setItem('rlx-welcome-seen','1');} catch (_) {} };
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),options);
      this.dialog.addEventListener('close',remember,options);
      this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},options);
      if (this.querySelector('[data-success]')) { try { localStorage.setItem('rlx-welcome-subscribed','1'); } catch (_) {} this.dialog.showModal(); return; }
      if (this.querySelector('[role=alert]')) { this.dialog.showModal(); return; }
      try { if(localStorage.getItem('rlx-welcome-subscribed')) return; } catch (_) {}
      if (this.dataset.designMode==='true') return;
      try {if(sessionStorage.getItem('rlx-welcome-seen'))return;} catch (_) {}
      this.ready=false;
      const show = () => {
        if(!this.ready || this.dialog.open || document.hidden || scrollY < innerHeight * .5)return;
        if(document.activeElement && document.activeElement.closest('form,dialog,[role=dialog]'))return;
        if([...document.querySelectorAll('dialog[open],[aria-modal=true]')].some(el=>el!==this.dialog && el.getClientRects().length))return;
        this.dialog.showModal();remember();this.ready=false;
      };
      this.timer=setTimeout(()=>{this.ready=true;show();},Number(this.dataset.delay)||30000);
      window.addEventListener('scroll',show,{passive:true,signal:this.abort.signal});
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
